<agpr-take-over-panel
    id="syndicatedMentionsTakeOverPanel"
    class="agpr-syndicatedMentionsTakeoverPanel"
    [splitHeader]="panelHeader"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    [hideSlideOverlay]="hideSlideOverlay"
    [responsiveWidth]="true"
    [minPanelWidth]="960"
    [maxPanelWidth]="1400"
    [showFooter]="false"
    [noScroll]="true"
    [noPadding]="true"
    [fullHeight]="true"
    (visibleChange)="handleVisibleChange($event)"
>
    <ng-template #noScrollContent>
        <div class="agpr-syndicatedMentionsTakeoverPanel-body">
            <div class="agpr-syndicatedMentionsTakeoverPanel-main">
                <agpr-mention-search-result
                    [topLabelMention]="currentPage === 1 ? originalMention : null"
                    [forceSyndicateSave]="true"
                    [topLabel]="'Monitor.syndicates.originalMention'"
                ></agpr-mention-search-result>
            </div>

            <aside class="agpr-syndicatedMentionsTakeoverPanel-sidebar">
                <agpr-right-sidebar
                    #rhpTabs
                    [loading]="isLoading"
                    (selectedTabIndexChange)="tabChange($event)"
                    (headerIconClicked)="openMentionTakeOver()"
                    [ngClass]="{
                        'agpr-rightSidebar--stickyTitle': rhpTabs.selectedTab?.id === 'monitoringMention',
                        'agpr-rightSidebar--noMention': !focusedMention
                    }"
                >
                    <agpr-tab
                        [id]="'syndicatedPanelMentionInfo'"
                        icon="fa-file"
                        tooltip="Monitoring.results.rhp.mention"
                        [headerIcon]="'fa-solid fa-duotone fa-circle-chevron-left'"
                        headerIconTooltip="Mention.results.rhp.mentionContent.headerIcon"
                    >
                        @if (mentions?.length) {
                            <agpr-mention-information
                                [id]="'syndicatedPanel_mentionInformation'"
                                [showInsights]="focusedMention && !!focusedMention.mentionId"
                            ></agpr-mention-information>
                        } @else {
                            <agpr-panel header="Mention.details.mention">
                                <agpr-message
                                    [severity]="messageSeverityEnum.noContent"
                                    [useWhiteBg]="true"
                                >
                                    {{ 'Monitoring.result.noMentionsAvailable' | localize }}
                                </agpr-message>
                            </agpr-panel>
                        }
                    </agpr-tab>

                    <agpr-entity-details-tab
                        [id]="'syndicatedPanelRhpTab.contactProfile'"
                        icon="fa-user"
                        tooltip="Discover.targeting.rhp.tabs.profileMeta"
                        [entityType]="entityTypes.CONTACT"
                        [syncOutletTabInfo]="false"
                        [noContactMessage]="
                            focusedMention?.author?.name
                                ? 'Monitor.entityProfile.noAdditionalInfo'
                                : 'Monitor.entityProfile.noContact'
                        "
                        (loading)="isLoading = $event"
                    ></agpr-entity-details-tab>

                    <agpr-entity-details-tab
                        [id]="'syndicatedPanelRhpTab.outletProfile'"
                        icon="fa-kit-duotone fa-agpr-outlet"
                        tooltip="Discover.targeting.rhp.tabs.outletProfileMeta"
                        [entityType]="entityTypes.OUTLET"
                        [noOutletMessage]="
                            focusedMention?.publication?.name
                                ? 'Monitor.entityProfile.noAdditionalInfo'
                                : 'Monitor.entityProfile.noOutlet'
                        "
                        (loading)="isLoading = $event"
                    ></agpr-entity-details-tab>

                    <agpr-tab
                        [id]="'syndicatedPanelResultsCharts'"
                        icon=" fa-pie-chart"
                        tooltip="Monitoring.results.rhp.charts"
                    >
                        <agpr-monitoring-result-charts></agpr-monitoring-result-charts>
                    </agpr-tab>

                    <agpr-entity-list-tab
                        [id]="'syndicatedPanelRhpTab.contactList'"
                        [entityMode]="entityTypes.CONTACT"
                        [tooltip]="'Monitoring.results.rhp.contactList.tooltip' | localize"
                        (showRhpTakeOver)="openEntityTakeover($event)"
                    ></agpr-entity-list-tab>

                    <agpr-entity-list-tab
                        [id]="'syndicatedPanelRhpTab.outletList'"
                        [entityMode]="entityTypes.OUTLET"
                        [tooltip]="'Monitoring.results.rhp.outletList.tooltip' | localize"
                        (showRhpTakeOver)="openEntityTakeover($event)"
                    ></agpr-entity-list-tab>
                </agpr-right-sidebar>
            </aside>
        </div>
    </ng-template>
</agpr-take-over-panel>
